import { render, staticRenderFns } from "./UserAccess.vue?vue&type=template&id=d87316e6&scoped=true&"
import script from "./UserAccess.vue?vue&type=script&lang=js&"
export * from "./UserAccess.vue?vue&type=script&lang=js&"
import style0 from "./UserAccess.vue?vue&type=style&index=0&id=d87316e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87316e6",
  null
  
)

export default component.exports